import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export const getCompletionColor = (value) => {
  const safeValue = Math.max(0, Math.min(100, Number(value) || 0));

  if (safeValue < 40) {
    // return { color: "#EF4444", bg: "rgba(239, 68, 68, 0.15)" };ef6969ff, #ef7575ff
        return { color: "#ef6969ff", bg: "rgba(239, 68, 68, 0.15)" };

  }

  if (safeValue < 80) {
    return { color: "#F59E0B", bg: "rgba(245, 158, 11, 0.15)" };
  }

  return { color: "#22C55E", bg: "rgba(34, 197, 94, 0.15)" };
};

export default function ProfileCompletion({
  value = 0,
  size = 34,
  thickness = 4,
  showLabel = false,
}) {
  const safeValue = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
  const { color } = getCompletionColor(safeValue);

  return (
    <Box
      sx={{
        position: "relative",
        width: size,
        height: size,
        flexShrink: 0,
        display: "inline-flex",
      }}
    >
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        thickness={thickness}
        sx={{ color: "rgba(255, 255, 255, 0.1)" }}
      />

      <CircularProgress
        variant="determinate"
        value={safeValue}
        size={size}
        thickness={thickness}
        sx={{
          color,
          position: "absolute",
          left: 0,
          top: 0,
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
          },
        }}
      />

      {showLabel && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: size <= 24 ? 8 : Math.round(size * 0.28),
              fontWeight: 700,
              lineHeight: 1,
              color,
            }}
          >
            {safeValue}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
